import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { SharedModule } from "../@shared/shared.module";

import { PagesRoutingModule } from './pages-routing.module';
import { LayoutComponent } from '../layout/layout.component';
import { FormsModule } from '@angular/forms';
import { SidebarComponent } from '../layout/sidebar/sidebar.component';
import { RulesComponent } from './rules/rules.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { StakesComponent } from './stakes/stakes.component';
import { MarketAnalysisComponent } from './market-analysis/market-analysis.component';
import { RefferAndEarnComponent } from './reffer-and-earn/reffer-and-earn.component';
import { BonusListComponent } from './bonus-list/bonus-list.component';
import { DepositWithdrawComponent } from './deposit-withdraw/deposit-withdraw.component';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { RulesPageComponent } from './rules-page/rules-page.component';


@NgModule({
  declarations: [
    LayoutComponent,
    SidebarComponent,
    RulesComponent,
    MyProfileComponent,
    ChangePasswordComponent,
    StakesComponent,
    MarketAnalysisComponent,
    DepositWithdrawComponent,
    BonusListComponent,
    RefferAndEarnComponent,
    RulesPageComponent
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    FormsModule,
    SharedModule,
    ProgressbarModule
  ],
  providers: [DatePipe],
})
export class PagesModule { }
